import { FC } from 'react';
import { Table } from 'rsuite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as SolidStar } from '@fortawesome/free-solid-svg-icons';
import { faStar as HallowStar } from '@fortawesome/free-regular-svg-icons';

import { RsCheckboxTable, useTableSort } from 'components/Rsuite/Table';

import {
  SuggestKeywordProperty,
  SuggestKeywordType,
  SUGGEST_KEYWORD_UNIQUE_KEY,
} from 'core/rtbCampaign/singlePage/keyword';

interface SuggestKeywordTableProps {
  data: SuggestKeywordType[];
  checkedKeys: Set<SuggestKeywordType[typeof SUGGEST_KEYWORD_UNIQUE_KEY]>;
  disabledKeys: Set<SuggestKeywordType[typeof SUGGEST_KEYWORD_UNIQUE_KEY]>;
  onSelect: (uniqueKey: string) => void;
  onAllSelect: () => void;
}

const stringifiedNumberSort = (cpcA, cpcB, sortType) => {
  switch (sortType) {
    case 'desc': {
      return Number(cpcB) - Number(cpcA);
    }
    case 'asc':
    default: {
      return Number(cpcA) - Number(cpcB);
    }
  }
};

export const SuggestKeywordTable: FC<SuggestKeywordTableProps> = ({
  data,
  checkedKeys,
  disabledKeys,
  onSelect,
  onAllSelect,
}) => {
  const { sortedData, sortColumn, sortType, handleSortColumn } = useTableSort(
    data,
    {
      [SuggestKeywordProperty.CPC]: stringifiedNumberSort,
      [SuggestKeywordProperty.PR]: stringifiedNumberSort,
    },
  );
  return (
    <RsCheckboxTable
      data={sortedData}
      uniqueKey={SUGGEST_KEYWORD_UNIQUE_KEY}
      checkedKeys={checkedKeys}
      onSelect={onSelect}
      onAllSelect={onAllSelect}
      disabledKeys={disabledKeys}
      tableConfig={{
        fillHeight: true,
        virtualized: true,
        sortColumn,
        sortType,
        onSortColumn: handleSortColumn,
        shouldUpdateScroll: false,
      }}
    >
      <Table.Column width={180} fixed sortable fullText>
        <Table.HeaderCell>關鍵字</Table.HeaderCell>
        <Table.Cell dataKey={SuggestKeywordProperty.SUGGEST_KEYWORD} />
      </Table.Column>
      <Table.Column width={176} sortable>
        <Table.HeaderCell>綜合品質分數</Table.HeaderCell>
        <Table.Cell dataKey={SuggestKeywordProperty.PR}>
          {({ star }) => <StarRate star={star} />}
        </Table.Cell>
      </Table.Column>
      <Table.Column width={130} sortable>
        <Table.HeaderCell>推薦出價</Table.HeaderCell>
        <Table.Cell dataKey={SuggestKeywordProperty.CPC}>
          {(item) => {
            return `NTD ${item[SuggestKeywordProperty.CPC]}`;
          }}
        </Table.Cell>
      </Table.Column>
    </RsCheckboxTable>
  );
};

const StarRate = ({ star }) => {
  const solidStars = new Array(star).fill(SolidStar);
  const hallowStars = new Array(5 - star).fill(HallowStar);
  return (
    <div className='flex gap-[6px]'>
      {[...solidStars, ...hallowStars].map((icon, i) => (
        <FontAwesomeIcon key={i} icon={icon} color='var(--rs-primary-400)' />
      ))}
    </div>
  );
};
